
// region JS Imports

// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
import RealEstate_FeaturedAgencyBanners_OneBanner_Cell from "concepts/app/real_estate_agencies/featured_agency_banners/one_banner"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports



interface Selector {
  scope:          string
  banner_section: string
}
interface InputSelector {
  scope?:          string
  banner_section?: string
}
const DEFAULT_SELECTOR = {
  scope:          "html",
  banner_section: ".page-section--featured-agency-banners",
}


class FeaturedAgencyBannerSidebar {
  protected selector: Selector
  protected $scope: UmbrellaInstance
  protected $banner_section: UmbrellaInstance

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = u(this.selector.scope)
    this.$banner_section = this.$scope.find(this.selector.banner_section)

    this.created()
  }

  protected created(){
    this.trackImpression()
    this.registerClickEventListeners()
  }
  protected getURLForTracking(){
    return this.$banner_section.data("tracking-url")
  }
  protected trackClick(banner_record_id: string | number){
    q_ajax_3({
      url:      this.getURLForTracking(),
      method:   "POST",
      dataType: "json",
      data:     {
        event_type:         this.$banner_section.data("tracking-event-types-clicked"),
        banner_record_ids:  [banner_record_id],
      },
    })
    .done()
  }
  protected registerClickEventListeners() {
    RealEstate_FeaturedAgencyBanners_OneBanner_Cell
    .getCurrentCellsIn(this.$banner_section).forEach((cell) => {
      const banner_record_id = cell.getBannerRecordId()

      // Track "Click"
      cell.onClick(() => {
        this.trackClick(banner_record_id)
      })
    })
  }
  protected trackImpression(){
    if (this.$banner_section.length === 0) return

    const banner_record_ids = RealEstate_FeaturedAgencyBanners_OneBanner_Cell
    .getCurrentCellsIn(this.$banner_section).map((cell) => cell.getBannerRecordId())

    q_ajax_3({
      url:      this.getURLForTracking(),
      method:   "POST",
      dataType: "json",
      data:     {
        event_type: this.$banner_section.data("tracking-event-types-shown"),
        banner_record_ids,
      },
    })
    .done()
  }
}

const Factory = {
  create(){
    return new FeaturedAgencyBannerSidebar()
  },
}

export {
  Factory,
}
